import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import LoginPage from "./pages/Login/LoginPage";

import MembersPage from "./pages/Members/MembersPage";
import BenefitsPage from "./pages/Benefits/BenefitsPage";
import AccessNotAllowed from "./pages/AccessNotAllowed/AccessNotAllowed";
import Questionaires from "./pages/Questionaires/Questionaires";
import "./App.css";

const App: React.FC = () => {
  const { isAuthenticated, user } = useAuth0();

  const userRolePath = process.env.REACT_APP_USER_ROLE_PATH as string;

  const userRole = user && user[userRolePath] ? user[userRolePath][0] : null;

  console.log(userRole);

  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route
        path="/participants"
        element={
          isAuthenticated && userRole ? (
            userRole === "Admin" || userRole === "Partner" ? (
              <MembersPage />
            ) : (
              <Navigate to="/access-not-allowed" />
            )
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/benefits"
        element={
          isAuthenticated && userRole ? (
            userRole === "Admin" || userRole === "Partner" ? (
              <BenefitsPage />
            ) : (
              <Navigate to="/access-not-allowed" />
            )
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/questionaires"
        element={
          isAuthenticated && userRole ? (
            userRole === "Admin" || userRole === "Partner" ? (
              <Questionaires />
            ) : (
              <Navigate to="/access-not-allowed" />
            )
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route path="/access-not-allowed" element={<AccessNotAllowed />} />
    </Routes>
  );
};

export default App;
